module.exports = __webpack_public_path__ + "static/img/about-06.00e6c8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/about-06.png
// module id = 0B7v
// module chunks = 0